@if (item) {
  <div style="position: relative">
    <div
      style="display: flex; max-width: 100vw"
      cdkDropList
      cdkDropListOrientation="horizontal"
      class="picture-cont-drag-list"
      [style.overflow]="overflow"
      (cdkDropListDropped)="drop($event, item.pictureContainers)">
      @for (subitem of item.pictureContainers; track subitem; let i = $index) {
        <div
          #item
          class="item-container picture-cont-drag-box picture-cont-drag-box--{{ containerLength }}"
          cdkDrag
          [cdkDragDisabled]="!contentEdit"
          [ngClass]="{ 'last-pic': containerLength - 1 === i, 'mobile-view': isMobile }">
          @if (contentEdit) {
            <span
              class="material-icons"
              cdkDragHandle
              style="position: absolute; top: 10px; left: 10px; cursor: pointer; z-index: 10; color: white">
              drag_indicator
            </span>
          }
          @if (contentEdit) {
            <div class="action-button-container">
              <coin-icon-button
                type="secondary"
                icon="close"
                (click)="deleteItem(i)"></coin-icon-button>
            </div>
          }
          <div class="pic-container">
            <div style="width: 100%; overflow: hidden; min-height: 350px; height: 33vh; max-height: 550px">
              <div
                class="pic-image"
                [ngStyle]="{ background: 'url(' + subitem.img + ')' }">
                <div
                  class="pic-text"
                  [ngStyle]="{ height: heightModified ? 'calc(100% - 40px)' : '100%' }">
                  <div class="underlay-full-width"></div>
                  <div style="flex: 1"></div>
                  <div style="position: relative">
                    <div
                      style="
                        width: 3px;
                        position: absolute;
                        left: 0;
                        top: 0.3rem;
                        bottom: 0.3rem;
                        background: linear-gradient(180deg, var(--purple700), var(--purple700));
                      "></div>
                    @if (!contentEdit) {
                      <h3 style="margin-bottom: 0px; margin-left: 15px; margin-top: 0px">{{ subitem.mainTitle }}</h3>
                    }
                    @if (contentEdit) {
                      <h3
                        #heading
                        style="margin-bottom: 0px; margin-left: 15px; margin-top: 0px"
                        [contentEditable]="contentEdit"
                        [textContent]="subitem.mainTitle"
                        (input)="subitem.mainTitle = heading.textContent"></h3>
                    }
                  </div>
                  @if (!contentEdit) {
                    <p style="margin-top: 16px; margin-bottom: 16px; min-height: 100px">{{ subitem.text }}</p>
                  }
                  @if (contentEdit) {
                    <p
                      #paragraph
                      style="margin-top: 16px; margin-bottom: 16px; min-height: 100px"
                      [contentEditable]="contentEdit"
                      [textContent]="subitem.text"
                      (input)="subitem.text = paragraph.textContent"></p>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="inputs">
            @if (contentEdit) {
              <coin-v2-text-input
                [label]="'cms.link-url' | translate"
                [placeholder]="'https://...'"
                [disabled]="!contentEdit"
                [(ngModel)]="subitem.link" />
            }
            @if (contentEdit) {
              <coin-v2-button
                type="secondary"
                svgIcon="edit"
                [text]="'cms.content-pages.change-image-button' | translate"
                (click)="editPicture(i)"></coin-v2-button>
            }
          </div>
        </div>
      }
      @if (showArrow('left') && !contentEdit) {
        <div
          animate.enter="fade-in"
          animate.leave="fade-out"
          class="arrow-container left"
          [ngClass]="{ 'scroll-opacity': refresh }"
          (click)="scroll('left')">
          <i class="icon icon--arrow-left"></i>
        </div>
      }
      @if (showArrow('right') && !contentEdit) {
        <div
          animate.enter="fade-in"
          animate.leave="fade-out"
          class="arrow-container"
          [ngClass]="{ 'scroll-opacity': refresh }"
          (click)="scroll('right')">
          <i class="icon icon--arrow-right"></i>
        </div>
      }
      @if (contentEdit) {
        <div class="action-button-container add">
          <coin-icon-button
            type="primary"
            icon="add"
            (click)="addImage()"></coin-icon-button>
        </div>
      }
    </div>
  </div>
}
